export default "__VITE_ASSET__43a2KW2Q__"